import {
	RETIREMENT_LOAN_AMOUNT_MAX,
	RETIREMENT_LOAN_AMOUNT_MIN,
	RETIREMENT_LOAN_KIND_VALUES,
	RETIREMENT_LOAN_YEARS_SPAN,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementLoanFormModel } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";
import { z } from "zod";

export const getRetirementLoanFormSchema = (currentYear: number) =>
	z.object({
		kind: z.enum(RETIREMENT_LOAN_KIND_VALUES),
		amount: z
			.number()
			.min(RETIREMENT_LOAN_AMOUNT_MIN)
			.max(RETIREMENT_LOAN_AMOUNT_MAX),
		endYear: z
			.number()
			.int()
			.min(currentYear)
			.max(currentYear + RETIREMENT_LOAN_YEARS_SPAN),
	}) satisfies z.ZodType<RetirementLoanFormModel>;
